import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from '@mui/material';

interface RecoveryCodeDialogProps {
  open: boolean;
  onClose: () => void;
  recoveryCode: string;
  onCopy: () => void;
  onGenerateNewCode: () => void;
}

const RecoveryCodeDialog: React.FC<RecoveryCodeDialogProps> = ({
  open,
  onClose,
  recoveryCode,
  onCopy,
  onGenerateNewCode,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Recovery Code</DialogTitle>
      <DialogContent>
        <Typography variant="body1">Your recovery code is: {recoveryCode}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onGenerateNewCode} color="secondary">
          Generate New Code
        </Button>
        <Button onClick={onCopy} color="primary">
          Copy
        </Button>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RecoveryCodeDialog;
